import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import InfoAPI from './InfoAPI';
import { getSessionNameFromUrl } from '../utils/Functions';

// Documentation:
// https://dev.twitch.tv/docs/embed/everything/

// https://dev.twitch.tv/docs/embed/chat/

const EmbeddedStream = ({ height = 40, sessionName }) => {
    const [channelName, setChannelName] = useState(null);

    useEffect(() => {
        const getChannelName = async () => {
            try {
                const bodyData = JSON.stringify({
                    'request_type': 'info',
                    'info_type': 'getsettings',
                    'session_name': getSessionNameFromUrl()
                });
                const jsonData = await InfoAPI(bodyData);
                const result = JSON.parse(jsonData.body);
                console.log(result);
                setChannelName(result.TW_channel_name);
            } catch (error) {
                console.error('Error fetching channel name:', error);
            }
        }
        getChannelName();
    }, [sessionName]);

    useEffect(() => {
        if (channelName) {
            const script = document.createElement('script');
            script.src = "https://embed.twitch.tv/embed/v1.js";
            script.async = true;
            document.body.appendChild(script);

            script.onload = () => {
                try {
                    const embed = new window.Twitch.Embed("twitch-player", {
                        width: '100%',
                        height: '100%',
                        channel: channelName,
                        layout: "video",
                        autoplay: true,
                        parent: ["localhost"],
                        // Add minimum dimensions to ensure proper display
                        muted: false
                    });

                    // Add event listeners for debugging
                    embed.addEventListener(window.Twitch.Embed.VIDEO_READY, () => {
                        console.log('The video is ready');
                    });

                    embed.addEventListener(window.Twitch.Embed.VIDEO_PLAY, () => {
                        console.log('The video started playing');
                    });

                    embed.addEventListener(window.Twitch.Embed.ENDED, () => {
                        console.log('The video ended');
                    });

                    embed.addEventListener(window.Twitch.Embed.ERROR, (error) => {
                        console.error('Error from Twitch embed:', error);
                    });
                } catch (error) {
                    console.error('Error initializing Twitch embed:', error);
                }
            };

            script.onerror = (error) => {
                console.error('Error loading Twitch script:', error);
            };

            return () => {
                document.body.removeChild(script);
            };
        }
    }, [channelName]);

    return (
        <Container 
            fluid 
            className="d-flex justify-content-center align-items-center p-0"
            style={{ 
                minHeight: `${height}vh`,
                width: '100%',
                backgroundColor: '#000'
            }}
        >
            <div className="d-flex">
                {channelName && (
                    <>
                        <div style={{
                            width: `${height * 16/9}vh`,  // Set width based on 16:9 ratio
                            height: `${height}vh`,
                            position: 'relative'
                        }}>
                            <div
                                id="twitch-player"
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    zIndex: 1
                                }}
                            />
                        </div>
                        
                    </>
                )}
            </div>
        </Container>
    );
};

export default EmbeddedStream;